export default __webpack_public_path__ + "static/media/siddhi.ee5e41a3.jpg";